export const standardCode =
`
  <VerticalSectionMarker title="Title" sections={sections} />
`;

export const landingPagesCode =
`
  <VerticalSectionMarker landing sections={sections} />
`;



// WEBPACK FOOTER //
// ./src/containers/components/VerticalSectionMarker/constants/verticalSectionMarkerCode.js